import { createAction } from "@reduxjs/toolkit";

// Spreadsheet Actions
export const initSpreadsheet = createAction("INIT_SPREADSHEET");
export const updateSpreadsheetData = createAction("UPDATE_SPREADSHEET_DATA");
export const updateSpreadsheetOverwrites = createAction(
  "UPDATE_SPREADSHEET_OVERWRITES"
);
export const addSpreadsheetPlot = createAction("ADD_SPREADSHEET_PLOT");
export const removeSpreadsheetPlot = createAction("REMOVE_SPREADSHEET_PLOT");
export const updatePlotVariables = createAction("UPDATE_PLOT_HEADERS");
export const updateSpreadsheetPlot = createAction("UPDATE_SPREADSHEET_PLOT");
export const updatePlotSize = createAction("UPDATE_PLOT_SIZE");
export const setPlotRequired = createAction("SET_PLOT_REQUIRED");
export const setPlotLocked = createAction("SET_PLOT_LOCKED");
